export default "__VITE_ASSET__d2c51b23__"